module.exports = __webpack_public_path__ + "static/media/mia@2x.a471b090.png";